// include team's acronyms in the description for easier search

import { CanaryStoreEntry } from '@bill/canary.react'

const canaryConfig: CanaryStoreEntry[] = [
  {
    description: 'when enabled, show maintenance screen',
    name: 'sputnik-maint-mode',
    value: false,
  },
  {
    description: 'when enabled, shows aire theme',
    name: 'show-skylab-aire-theme',
    value: false,
  },
  {
    description: 'when enabled, shorten the time that the timeout warning modal is displayed and active to 15 seconds',
    name: 'reduceAccessTokenTimeout',
    value: false,
  },
  {
    description: 'when enabled, enables advanced onboarding return flow logic',
    name: 'advanced-onboarding-return-flow',
    value: false,
  },
  {
    description: 'COM: when enabled, show web bank changes',
    name: 'show-web-bank',
    value: false,
  },
  {
    description: 'COM: when enabled, show MFA logic',
    name: 'show-mfa-logic',
    value: false,
  },
  {
    description: 'COM: when enabled, show credit app dashboard redesign',
    name: 'rollout-credit-app-dashboard-redesign',
    value: false,
  },
  {
    description: 'UW: when enabled, show standard credit line offer page with amount selection slider',
    name: 'show-standard-line-with-selection',
    value: true,
  },
  {
    metadata: {
      description:
        'COM: when enabled, shows outsourced accountant management on the people info section of the credit application',
    },
    name: 'rollout-outsourced-accountant-people-info-migration',
    value: false,
  },
]

export default canaryConfig
